<template>
	<div class='main-component'>

		<MainHeader
			@open-tech-support='openModalTechSupport'
			@open-change-pass='openModalChangePass'
			@open-map='openModalMap'
		/>

		<div class='main-component-content'>
			<router-view/>
		</div>

		<b-modal ref='modal-tech-support' scrollable hide-footer>
			<template #modal-title>
				<b-icon icon='headset' class='mr-3'></b-icon>
				Техническая поддержка
			</template>
			<TechSupport @cancel='closeModalTechSupport'/>
		</b-modal>

		<b-modal ref='modal-change-pass' scrollable hide-footer>
			<template #modal-title>
				<b-icon icon='headset' class='mr-3'></b-icon>
				Изменение пароля
			</template>
			<ChangePass @cancel='closeModalChangePass'/>
			<!-- <div> llala lala change pass </div> -->
		</b-modal>

		<b-modal ref='modal-map' size='lg' scrollable hide-footer>
			<template #modal-title>
				Карта
			</template>
		</b-modal>

	</div>
</template>

<script>
	import MainHeader from '@/components/MainHeader';
	import TechSupport from '@/components/TechSupport';
	import ChangePass from '@/components/ChangePass';

	export default {
		name: 'MainView',
		components: {
			MainHeader,
			TechSupport,
			ChangePass,
		},

		methods: {
			openModalTechSupport() {
				this.$refs['modal-tech-support'].show();
			},
			closeModalTechSupport() {
				this.$refs['modal-tech-support'].hide();
			},

			openModalChangePass() {
				this.$refs['modal-change-pass'].show();
			},
			closeModalChangePass() {
				this.$refs['modal-change-pass'].hide();
			},


			openModalMap() {
				this.$refs['modal-map'].show();
			},
			closeModalMap() {
				this.$refs['modal-map'].hide();
			},
		}
	};
</script>

<style scoped>
	.main-component {
		height: 100vh;
		display: flex;
		flex-direction: column;
	}

	.main-component-content {
		/*height: 100%;*/
		flex: 1;
		overflow-y: auto;
		overflow-x: hidden;
		/*width: 100vw;*/
	}
</style>